import React from 'react';

import PropTypes from 'prop-types';

import { TENANT_ID } from 'global/constants';

import { getBaseUrl } from 'utils/UrlUtil';
import { getTenantId } from 'utils/tenantUtil';

export const InfoLink = ({ infoLink }) => {
  if (!infoLink) {
    return null;
  }

  if (!Array.isArray(infoLink)) {
    return (
      <a href={getBaseUrl() + infoLink} download className="download-item">
        : Link zum Dokument
      </a>
    );
  }

  if (infoLink.length === 2) {
    if (getTenantId() === TENANT_ID.MTN) {
      return (
        <span>
          ,{' '}
          <a href={getBaseUrl() + infoLink[0]} download className="download-item">
            STROM
          </a>{' '}
          und{' '}
          <a href={getBaseUrl() + infoLink[1]} download className="download-item">
            GAS
          </a>
        </span>
      );
    }
    return (
      <span>
        ,{' '}
        <a href={getBaseUrl() + infoLink[1]} download className="download-item">
          NordNetz GmbH
        </a>{' '}
        und{' '}
        <a href={getBaseUrl() + infoLink[0]} download className="download-item">
          Schleswig-Holstein Netz GmbH
        </a>
      </span>
    );
  }

  return (
    <span>
      :{' '}
      <a href={getBaseUrl() + infoLink[0]} download className="download-item">
        ElbEnergie GmbH
      </a>
      ,{' '}
      <a href={getBaseUrl() + infoLink[1]} download className="download-item">
        HanseGas GmbH
      </a>
      ,{' '}
      <a href={getBaseUrl() + infoLink[2]} download className="download-item">
        NordNetz GmbH
      </a>{' '}
      und{' '}
      <a href={getBaseUrl() + infoLink[3]} download className="download-item">
        Schleswig-Holstein Netz GmbH
      </a>
    </span>
  );
};

InfoLink.propTypes = {
  infoLink: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
};

InfoLink.defaultProps = {
  infoLink: null,
};
